import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you can add the logic to handle the form submission
    console.log("Form submitted:", formData);
    // Reset the form data
    setFormData({
      name: "",
      email: "",
      message: "",
    });
  };

  return (
    <div className="flex flex-col items-center justify-center bg-primary">
      <h2 className="text-2xl md:text-4xl font-bold text-white mb-6">
        Contact Us
      </h2>
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md flex flex-col space-y-4 p-4"
      >
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Your Name"
          required
          className="px-4 py-2 rounded-[50px] text-black"
        />
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Your Email"
          required
          className="px-4 py-2 rounded-[50px] text-black"
        />
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Your Message"
          required
          className="px-4 py-2 rounded-[20px] text-black h-32"
        />
        <button
          type="submit"
          className="px-5 py-3 text-lg text-primary bg-white rounded-[50px] hover:bg-primary hover:text-white transition-colors duration-300"
        >
          Send Message
        </button>
      </form>
      <img
        loading="lazy"
        src="/images/down2.svg"
        className="w-full bg-secondary"
        alt="waves"
      />
    </div>
  );
};

export default Contact;
